import React, { useState, useEffect, useRef } from 'react';
import styles from './ShortStoriesBanner.module.css';
import { useHeroSectionsByTypePublic } from '../../hooks/herosection/useHeroSectionPublicHooks';

function ShortStoriesBanner({ language }) {
  const { heroSections, isLoading: isLoadingHeroSections } =
      useHeroSectionsByTypePublic("Home");
  const [currentIndex, setCurrentIndex] = useState(0);
  const autoplayTimerRef = useRef(null);
  
  // Handle autoplay functionality
  useEffect(() => {
    if (heroSections && heroSections.length > 1) {
      autoplayTimerRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % heroSections.length);
      }, 8000); // Change story every 4 seconds
    }
    
    return () => {
      if (autoplayTimerRef.current) {
        clearInterval(autoplayTimerRef.current);
      }
    };
  }, [heroSections]);
  
  // Handle manual navigation
  const goToStory = (index) => {
    setCurrentIndex(index);
    // Reset autoplay timer when manually navigating
    if (autoplayTimerRef.current) {
      clearInterval(autoplayTimerRef.current);
      autoplayTimerRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % heroSections.length);
      }, 4000);
    }
  };

  if (isLoadingHeroSections) {
    return <div className={styles.loadingContainer}><div className={styles.loader}></div></div>;
  }

  if (!heroSections || heroSections.length === 0) {
    return (
      <div className={styles.errorContainer}>
        <h2>No stories available at the moment</h2>
        <p>Please check back later or try another language</p>
      </div>
    );
  }

  const currentSection = heroSections[currentIndex];
  const currentStory = currentSection.audio_data;
  
  return (
    <div className={styles.bannerContainer}>
      <div 
        className={styles.bannerBackground}
        style={{ backgroundImage: `url(${currentSection.computer_image || currentStory.computer_image_url})` }}
      >
        <div className={styles.bannerGradient}>
          <div className={styles.bannerContent}>
           
            
            <div className={styles.actionButtons}>
              <button className={styles.playButton}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 3V21L19 12L5 3Z" fill="currentColor" />
                </svg>
                Play
              </button>
            
            </div>
          </div>
        </div>
      </div>
      
      {heroSections.length > 1 && (
        <div className={styles.storyIndicators}>
          {heroSections.map((_, index) => (
            <button 
              key={index} 
              className={`${styles.indicator} ${index === currentIndex ? styles.active : ''}`}
              onClick={() => goToStory(index)}
              aria-label={`Go to story ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}


export default ShortStoriesBanner;